<template>
  <v-menu 
    left 
    min-width   = "25%"
    max-width   = "25%"
  >

    <template v-slot:activator="{ on: onMenu }">

      <v-tooltip 
        bottom
        open-delay    = "500"
      >

        <template v-slot:activator="{ on: onTooltip }">
          <v-btn 
            depressed 
            color       = "primary" 
            class       = "px-4 py-6" 
            v-on        = "{...onMenu, ...onTooltip }" 
            
            :disabled   = "recentFiles.length === 0"
          >
            <v-icon>mdi-history</v-icon>
          </v-btn>
        </template>

        <span>Recently Opened Files</span>

      </v-tooltip>

    </template>

    <v-list>
      <v-list-item
        v-for       = "(file, index) in recentFiles"
        :key        = "index"
        @click      = "$emit('input', { path: file.path, type: file.open ? 'growing' : 'video' })"
      >
        <v-list-item-content>
          <v-list-item-title>{{ file.filename }} </v-list-item-title>
          <v-list-item-subtitle class="subtitle_width_fix">{{ file.folder }}</v-list-item-subtitle>
          <v-list-item-subtitle v-if="file.open"> Opened as Growing File </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import { toRecentFileList } from '@/store/utilities/history.utils';

// #endregion Imports

export default {

  // #region Properties

  name:     'RecentFileSelector',
  computed: {
    ...mapState([
      'history'
    ]),
    recentFiles() {
      return (this.history.history ? toRecentFileList(this.history.history) : []);
    }
  },

  // #endregion Properties

}
</script>

<style scoped>

  .v-list-item__title {
    white-space: normal;
    word-wrap: break-word;
  }

</style>